var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "28",
      "height": "29"
    }
  }, _vm.$listeners), [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 28.305v-28h28v28z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M22.401 17.903h-2.4v-2.4h2.4zm0 4.801h-2.4v-2.4h2.4zm-4.8-14.402h-2.4v-2.4h2.4zm0 4.8h-2.4v-2.4h2.4zm0 4.801h-2.4v-2.4h2.4zM12.8 8.302h-2.4v-2.4h2.4zm0 4.8h-2.4v-2.4h2.4zm0 4.801h-2.4v-2.4h2.4zm-4.801-4.8h-2.4v-2.4h2.4zm0 4.8h-2.4v-2.4h2.4zm0 4.801h-2.4v-2.4h2.4zm12.002-9.601V3.5H7.999v4.8h-4.8v16.803h9.6v-4.8H15.2v4.8h9.602v-12H20Z"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }